/**
 * @flow
 * @relayHash a33828b31bc1d6b91982ecdadc72966d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CheckContractSigningPermissionMutationVariables = {|
  contractTemplateId: string,
  contractValue: any,
|};
export type CheckContractSigningPermissionMutationResponse = {|
  +checkContractSigningPermission: ?{|
    +canSign: ?boolean,
    +reason: ?string,
  |}
|};
export type CheckContractSigningPermissionMutation = {|
  variables: CheckContractSigningPermissionMutationVariables,
  response: CheckContractSigningPermissionMutationResponse,
|};
*/


/*
query CheckContractSigningPermissionMutation(
  $contractTemplateId: ID!
  $contractValue: Decimal!
) {
  checkContractSigningPermission(contractTemplateId: $contractTemplateId, contractValue: $contractValue) {
    canSign
    reason
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "contractTemplateId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "contractValue",
    "type": "Decimal!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "checkContractSigningPermission",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "contractTemplateId",
        "variableName": "contractTemplateId"
      },
      {
        "kind": "Variable",
        "name": "contractValue",
        "variableName": "contractValue"
      }
    ],
    "concreteType": "CheckContractSigningPermission",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "canSign",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "reason",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CheckContractSigningPermissionMutation",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CheckContractSigningPermissionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "CheckContractSigningPermissionMutation",
    "id": null,
    "text": "query CheckContractSigningPermissionMutation(\n  $contractTemplateId: ID!\n  $contractValue: Decimal!\n) {\n  checkContractSigningPermission(contractTemplateId: $contractTemplateId, contractValue: $contractValue) {\n    canSign\n    reason\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '73c1a2bdd696f9195b5fc77585937023';
module.exports = node;
